<template>
  <div>
    Sync In....
  </div>
</template>

<script>

import { Auth } from 'aws-amplify';
import { syncUpUser } from '../models/user';

export default {
  name: 'Sync',
  data() {
    return {};
  },
  async mounted() {
    Auth.currentAuthenticatedUser().then(async (cogUser) => {
      await syncUpUser(cogUser);
    }).catch(() => {
      console.log('something went wrong');
    });
  },
};
</script>
